import React, { Component, useState, useEffect, useMemo } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
// import { withStyles } from '@mui/styles';
// import DollarIcon from '@mui/icons-material/AttachMoney';
// import Typography from '@mui/material/Typography';
import CircularProgress from "@mui/material/CircularProgress";
// import { translate } from 'react-admin';
import Button from "@mui/material/Button";
import { Title, GET_LIST, useLocale, useTranslate } from "react-admin";
import { Link } from "react-router-dom";
import { GetCurrentUserRoles } from "../common/common";
import icon_retailer from "./../images/icon-retailer.svg";
import icon_order from "./../images/icon-order.svg";
import { getLocalStorageKey } from "../common/common";
import dataProvider from "../myRestProvider";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
// import CardIcon from './CardIcon';

// const styles = {
//     main: {
//         flex: '1',
//         marginRight: '1em',
//         marginTop: 20,
//     },
//     card: {
//         overflow: 'inherit',
//         textAlign: 'right',
//         padding: 16,
//         minHeight: 52,
//     },
// };

const Dashboard = () => {
  const [stats_data, setStats_data] = React.useState(null);
  // const locale = useLocale();
  const locale = localStorage.getItem("language");
  const translate = useTranslate();
    const localStorageAppType = getLocalStorageKey("app_type");
    const [baseThemeColor, setBaseThemeColor] = useState("clickittheme");
  
    useEffect(() => {
      if (localStorageAppType === "HOLCIM") {
        setBaseThemeColor("holcimtheme");
      } else {
        setBaseThemeColor("clickittheme");
      }
    }, [localStorageAppType]);
  


  React.useLayoutEffect(() => {
    getStatsData();
  }, []);

  const getStatsData = () => {
    // const options = CommonHeaderOption();
    // const apiUrl = RUN_TIME_API_ENDPOINT;
    // fetch(`${apiUrl}/dashboard_stats`, options)
    dataProvider(GET_LIST, "dashboard_stats", {})
      .then((json) => {
        // this.setState({ stats_data: json.data });
        setStats_data(json.data);
      })
      .catch((error) => console.log("error", error));
  };


  const dashboardRenderRole = () => {
    let roleData = GetCurrentUserRoles();
    const showAllOrders = getLocalStorageKey("show_all_orders");
    if (roleData === false) {
      return <div> </div>;
    }

    return (
      <div>
        <div className="dashboard-container">
          <div className="dashboard-inner">
            <div className="dashboard-box-container">
              <div className="dashboard-box">
                {" "}
                <Link to={`/businesses`}>
                  <img
                    alt="Retailer Icon"
                    src={icon_retailer}
                    className="icon-image-dashboard"
                  />
                </Link>
                <p className="dashboard-label">Retailers</p>
                <p className="dashboard-value">
                  <Link to={`/businesses`}>{stats_data.retailers_total}</Link>
                </p>
              </div>
              <div className="dashboard-box">
                <Link
                  to={`/${
                    showAllOrders
                      ? "sap_digital_orders"
                      : "sap_digital_app_orders"
                  }`}
                >
                  <img
                    alt="Order Icon"
                    src={icon_order}
                    className="icon-image-dashboard"
                  />
                </Link>
                <p className="dashboard-label">Digital Order By Retailers</p>
                <p className="dashboard-value">
                  <Link
                    to={`/${
                      showAllOrders
                        ? "sap_digital_orders"
                        : "sap_digital_app_orders"
                    }`}
                  >
                    {stats_data.digital_orders_total}
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card className="welcom_container">
        <center>
          <Title title={translate(baseThemeColor === 'clickittheme'? "resources.my_menu.fields.welcome_msg" : "resources.my_menu.fields.welcome_msg_holcim")} />
        </center>
        <CardContent>
          {stats_data ? (
            dashboardRenderRole()
          ) : (
            <div className="custom-loader">
              <CircularProgress />
            </div>
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default Dashboard;
